import { FileQuestion, Home } from "lucide-react";
import type React from "react";
import { useNavigate } from "react-router-dom";
import { strings } from "@/I18n";
import { Button } from "@/v2/ui/primitives/button";
import { Card } from "@/v2/ui/primitives/card";

const NotFoundContainer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-bg-muted/30 tw-flex tw-items-center tw-justify-center">
      <Card className="tw-w-full tw-max-w-md tw-p-8 tw-text-center">
        <FileQuestion className="tw-h-16 tw-w-16 tw-mx-auto tw-text-muted-foreground/50" />
        <h1 className="tw-text-6xl tw-font-bold tw-mt-4">404</h1>
        <p className="tw-text-xl tw-font-medium tw-mt-2">
          {strings("notFound.title")}
        </p>
        <p className="tw-text-muted-foreground tw-mt-1">
          {strings("notFound.description")}
        </p>
        <Button className="tw-mt-6" onClick={() => navigate("/")}>
          <Home className="tw-mr-2 tw-h-4 tw-w-4" />
          {strings("notFound.goHome")}
        </Button>
      </Card>
    </div>
  );
};

export default NotFoundContainer;
